import React, { useContext } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { Row, Card } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import HeaderControl, { headerControlTester } from './Header'
import BodyControl, { bodyControlTester } from './Body'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { JsonForms } from '@jsonforms/react'
import { Formik } from 'formik'
import { checkError } from 'designer/component/validation'
import { getElementRendererList } from 'designer/component/control/renderer/RendererHelper'

const hasZeroPadding = (padding) => {
  if (padding === 0) return true
  if (typeof padding !== 'string') return false

  const values = padding.trim().split(/\s+/).filter(Boolean)
  return (
    values.length > 0 &&
    values.every((value) => Number.parseFloat(value) === 0)
  )
}

const PageControl = (props) => {
  const renderers = [
    ...materialRenderers,
    { tester: headerControlTester, renderer: HeaderControl },
    { tester: bodyControlTester, renderer: BodyControl },
  ]
  const { config, schema, uischema } = props
  const { isOpenModal } = config

  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const contentElements = (uischema.elements || [])
    .reduce(
      (elements, element) => [
        ...elements,
        ...getElementRendererList(element),
      ],
      [],
    )
    .filter(({ uiType }) => uiType !== 'layout' && uiType !== 'system')
  const isNoPaddingComponent =
    contentElements.length === 1 &&
    contentElements[0].uiType === 'component' &&
    hasZeroPadding(contentElements[0].layoutPadding)

  const initialValues = {}
  const validate = (values) => {
    let errors = checkError(jsonForm, values)
    return errors
  }

  return (
    <Card
      className={`${!uischema.cardColor && `border-${uischema.variant}`}`}
      style={{
        border: !isOpenModal && `1px solid ${uischema.cardColor}`,
        margin: 0,
        boxShadow: !isOpenModal && uischema.isShowBoxShadow ? '' : 'unset',
      }}
    >
      {!isOpenModal && uischema.isShowTitle && (
        <Card.Header
          className={`${!uischema.cardColor && `bg-${uischema.variant}`}`}
          style={{ backgroundColor: uischema.cardColor }}
        >
          <Card.Title className="m-0" style={{ color: uischema.textColor }}>
            {uischema.title}
          </Card.Title>
        </Card.Header>
      )}
      <Card.Body className={isNoPaddingComponent ? 'p-0' : 'py-2 px-0'}>
        <Formik initialValues={initialValues} validate={validate}>
          <JsonForms
            schema={schema}
            uischema={uischema}
            config={{
              droppableId: uischema.key,
            }}
            renderers={renderers}
            cells={materialCells}
          />
        </Formik>
      </Card.Body>
    </Card>
  )
}

export const pageControlTester = rankWith(3, scopeEndsWith('layout'))

export default withJsonFormsControlProps(PageControl)
